<template>
  <div class="containerIndex">
    <!-- header -->
    <div id="topPart">
      <div class="top wrap">
        <!-- 适配显示菜单 -->
        <div
          class="shownavnone"
          v-if="isClose"
        >
          <a
            href="#"
            @click="shownonenav"
          >
            <span></span>
            <span></span>
            <span></span>
          </a>
        </div>
        <!-- 头部商标 -->
        <div class="topLogoMain">
          <div class="topLogoMainLeft">
            <a href="/"><img :src="logo" /></a>
          </div>
        </div>
        <!-- 导航菜单 -->
        <div class="topMenu">
          <div class="nav_box">
            <ul class="nav_box_list clearfloat">
              <li style="border-left: none">
                <div class="nav_grop">
                  <h2><router-link to="/">首页</router-link></h2>
                  <div class="hoverline"></div>
                </div>
              </li>
              <li
                v-for="(item, index) in navList"
                :key="index"
                :class="{ borderR: index == navList.length - 1 }"
                @mouseenter="navShow(item.channelId)"
                @mouseleave="navClose()"
              >
                <div class="nav_grop">
                  <!-- 一级菜单 -->
                  <h2>
                    <!-- 有二级URL则跳转 -->
                    <a
                      v-if="
                        item.child.length &&
                        item.child[0].url &&
                        item.child[0].url !== ''
                      "
                      target="_blank"
                      :href="item.child[0].url"
                    >
                      {{ item.name }}
                    </a>
                    <!-- 有二级，无URL，跳本地 -->
                    <a
                      v-if="
                        item.child.length &&
                        (!item.child[0].url || item.child[0].url == '')
                      "
                      target="_blank"
                      :href="
                        item.child[0].catalog == 1
                          ? `/listPage/${item.child[0].entTChannelUuid}`
                          : item.child[0].catalog == 2
                          ? `/list/${item.child[0].entTChannelUuid}`
                          : `/list/${item.child[0].entTChannelUuid}`
                      "
                    >
                      {{ item.name }}
                    </a>
                    <!-- 无二级，直接跳本地 -->
                    <a
                      v-if="!item.child.length"
                      target="_blank"
                      :href="
                        item.catalog == 1
                          ? `/listPage/${item.entTChannelUuid}`
                          : item.catalog == 2
                          ? `/list/${item.entTChannelUuid}`
                          : `/list/${item.entTChannelUuid}`
                      "
                    >
                      {{ item.name }}
                    </a>
                  </h2>
                  <div class="hoverline"></div>
                  <el-collapse-transition>
                    <!-- 下拉菜单 -->
                    <div
                      class="nav_down"
                      v-show="navDown == item.channelId"
                    >
                      <div
                        class="wrap nav_down_wrap clearfloat"
                        v-show="item.child.length != 0"
                      >
                        <p
                          v-for="(item1, index1) in item.child"
                          :key="index1"
                        >
                          <!-- 无三级，无URL，跳本地 -->
                          <a
                            v-if="
                              !item1.child.length &&
                              (!item1.url || item1.url == '') &&
                              item1.entTChannelUuid !== '02320005' &&
                              item1.entTChannelUuid !== '02310007' &&
                              item1.entTChannelUuid !== '02310006'
                            "
                            :href="
                              item1.catalog == 1
                                ? `/listPage/${item1.entTChannelUuid}`
                                : item1.catalog == 2
                                ? `/list/${item1.entTChannelUuid}`
                                : `/list/${item1.entTChannelUuid}`
                            "
                            target="_blank"
                          >
                            {{ item1.name }}
                          </a>
                          <!-- 无三级，跳URL -->
                          <a
                            v-if="
                              !item1.child.length &&
                              item1.url &&
                              item1.url !== '' &&
                              item1.entTChannelUuid !== '02320005' &&
                              item1.entTChannelUuid !== '02310007' &&
                              item1.entTChannelUuid !== '02310006'
                            "
                            :href="item1.url"
                            target="_blank"
                          >
                            {{ item1.name }}
                          </a>
                          <!-- 特殊情况，无三级，为电视新闻，跳转建投的电视新闻 -->
                          <!-- <a
                            v-if="
                              !item1.child.length &&
                              item1.entTChannelUuid == '02310007'
                            "
                            href="http://www.gsjtw.cc/pressCenter/00190010"
                            target="_blank"
                          >
                            {{ item1.name }}
                          </a> -->
                          <!-- 特殊情况，无三级，为甘肃建投报，跳转建投的甘肃建投报 -->
                          <!-- <a
                            v-if="
                              !item1.child.length &&
                              item1.entTChannelUuid == '02310006'
                            "
                            href="http://www.gsjtw.cc/newsPaper/001900100004"
                            target="_blank"
                          >
                            {{ item1.name }}
                          </a> -->
                        </p>
                      </div>
                    </div>
                  </el-collapse-transition>
                </div>
              </li>
            </ul>
            <div
              class="searchicon"
              @click="gosearchpage"
            >
              <!-- <i class="el-icon-search"></i> -->
              <img src="../assets/img/newsearch.png" />
            </div>
          </div>
        </div>
        <!-- 适配菜单 -->
        <div
          class="navnone"
          v-if="!isClose"
        >
          <div
            class="close"
            @click="closenav"
          >
            <a href="#">
              <img
                :src="close"
                alt="close"
              />
            </a>
          </div>
          <ul>
            <li>
              <a href="/">首页</a>
            </li>
            <li
              v-for="(item, index) in navList"
              :key="index"
            >
              <a
                v-if="
                  item.child.length &&
                  item.child[0].url &&
                  item.child[0].url !== ''
                "
                target="_blank"
                :href="item.child[0].url"
              >
                {{ item.name }}
              </a>
              <a
                v-if="
                  item.child.length &&
                  (!item.child[0].url || item.child[0].url == '')
                "
                :href="
                  item.catalog == 1
                    ? `/listPage/${item.child[0].entTChannelUuid}`
                    : item.catalog == 2
                    ? `/list/${item.child[0].entTChannelUuid}`
                    : `/list/${item.child[0].entTChannelUuid}`
                "
              >
                {{ item.name }}
              </a>
              <a
                v-if="!item.child.length"
                :href="
                  item.catalog == 1
                    ? `/listPage/${item.entTChannelUuid}`
                    : item.catalog == 2
                    ? `/list/${item.entTChannelUuid}`
                    : `/list/${item.entTChannelUuid}`
                "
              >
                {{ item.name }}
              </a>
              <ul class="innerul">
                <li
                  v-for="(item1, index1) in item.child"
                  :key="index1"
                >
                  <!-- 无三级,有URL,跳url -->
                  <a
                    v-if="!item1.child.length && item1.url && item1.url !== ''"
                    :href="item1.url"
                    target="_blank"
                  >
                    {{ item1.name }}
                  </a>
                  <!-- 无三级,无URL,跳本地二级 -->
                  <a
                    v-if="
                      !item1.child.length && (!item1.url || item1.url == '')
                    "
                    :href="
                      item1.catalog == 1
                        ? `/listPage/${item1.entTChannelUuid}`
                        : item1.catalog == 2
                        ? `/list/${item1.entTChannelUuid}`
                        : `/list/${item1.entTChannelUuid}`
                    "
                    target="_blank"
                  >
                    {{ item1.name }}
                  </a>
                  <!-- 有三级,跳三级URL -->
                  <a
                    v-if="
                      item1.child.length &&
                      (!item1.child[0].url ||
                        item1.child[0].url == '' ||
                        item1.child[0].url == null)
                    "
                    :href="
                      item1.catalog === 1
                        ? `/listPage/${item1.child[0].entTChannelUuid}`
                        : item1.catalog === 2
                        ? `/list/${item1.child[0].entTChannelUuid}`
                        : `/list/${item1.child[0].entTChannelUuid}`
                    "
                    target="_blank"
                  >
                    {{ item1.name }}
                  </a>
                </li>
              </ul>
            </li>
          </ul>
          <!-- 搜索 -->
          <div class="topLogoMainRight">
            <div class="header_search">
              <div>
                <el-input
                  v-model="searchValue"
                  placeholder="请输入标题"
                ></el-input>
                <el-button
                  type="submit"
                  @click="searchSubmit"
                  >搜索</el-button
                >
              </div>
            </div>
          </div>
          <div style="height: 80px"></div>
        </div>
      </div>
    </div>
    <!-- main -->
    <div
      class="mainBox containerMain"
      :style="containerStyle"
    >
      <router-view></router-view>
    </div>
    <!-- footer -->
    <div class="footerBox">
      <div class="footerall wrap">
        <div class="footertop">
          <div class="footertopL fl">
            <p>
              <a
                href="#"
                target="_blank"
              >
                <img
                  :src="tooterlimg"
                  alt="华陇能创股份有限公司的页尾LOGO"
                  style="width: 100%; height: auto"
                />
              </a>
            </p>
            <p>地址：甘肃省兰州市安宁区北滨河西路516号</p>
            <p>电话：</p>
            <p>邮箱：hlncgfyxgs@163.com</p>
          </div>
          <div class="footertopM fl">
            <ul class="footnav">
              <li
                v-for="(item, index) in fakenav"
                :key="index"
                class="fl"
              >
                <!-- 有二级,有URL,跳转URL -->
                <a
                  v-if="
                    item.child.length &&
                    item.child[0].url &&
                    item.child[0].url !== ''
                  "
                  target="_blank"
                  :href="item.child[0].url"
                >
                  {{ item.name }}
                </a>
                <!-- 有二级，无URL，跳本地 -->
                <a
                  v-if="
                    item.child.length &&
                    (!item.child[0].url || item.child[0].url == '')
                  "
                  target="_blank"
                  :href="
                    item.catalog == 1
                      ? `/listPage/${item.child[0].entTChannelUuid}`
                      : item.catalog == 2
                      ? `/list/${item.child[0].entTChannelUuid}`
                      : `/list/${item.child[0].entTChannelUuid}`
                  "
                >
                  {{ item.name }}
                </a>
                <!-- 无二级，直接跳本地 -->
                <a
                  v-if="!item.child.length"
                  target="_blank"
                  :href="
                    item.catalog == 1
                      ? `/listPage/${item.entTChannelUuid}`
                      : item.catalog == 2
                      ? `/list/${item.entTChannelUuid}`
                      : `/list/${item.entTChannelUuid}`
                  "
                >
                  {{ item.name }}
                </a>
                <ul>
                  <li
                    v-for="(item1, index1) in item.child"
                    :key="index1"
                  >
                    <!-- 无三级,有URL,跳url -->
                    <a
                      v-if="
                        !item1.child.length && item1.url && item1.url !== ''
                      "
                      :href="item1.url"
                      target="_blank"
                    >
                      {{ item1.name }}
                    </a>
                    <!-- 无三级,无URL,跳本地二级 -->
                    <a
                      v-if="
                        !item1.child.length && (!item1.url || item1.url == '')
                      "
                      :href="
                        item1.catalog == 1
                          ? `/listPage/${item1.entTChannelUuid}`
                          : item1.catalog == 2
                          ? `/list/${item1.entTChannelUuid}`
                          : `/list/${item1.entTChannelUuid}`
                      "
                      target="_blank"
                    >
                      {{ item1.name }}
                    </a>
                    <!-- 有三级,跳三级URL -->
                    <a
                      v-if="
                        item1.child.length &&
                        (!item1.child[0].url ||
                          item1.child[0].url == '' ||
                          item1.child[0].url == null)
                      "
                      :href="
                        item1.catalog === 1
                          ? `/listPage/${item1.child[0].entTChannelUuid}`
                          : item1.catalog === 2
                          ? `/list/${item1.child[0].entTChannelUuid}`
                          : `/list/${item1.child[0].entTChannelUuid}`
                      "
                      target="_blank"
                    >
                      {{ item1.name }}
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          <div class="footertopR fr">
            <a
              href="#"
              target="_blank"
            >
              <img
                :src="tooterrimg"
                alt="华陇能创股份有限公司的页尾LOGO"
                style="width: 100%; height: auto"
              />
            </a>
          </div>
        </div>
        <div style="clear: both"></div>
        <div class="footerbot">
          <span>Copyrights ©</span>
          <span>2024 All Rights Reserved 版权所有</span>
          <span>华陇能创股份有限公司</span>
          <a
            href="http://beian.miit.gov.cn/"
            target="_blank"
            >陇ICP备2020004082号-1</a
          >
          <a
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=62010502001483"
            target="_blank"
          >
            <img src="../assets/img/ba.png" />
            <!-- 甘公网安备 62010502001483号 -->
          </a>
          <span>设计制作</span>
          <a
            href="http://www.hongdianwangluo.com"
            target="_blank"
            >宏点网络</a
          >
        </div>
      </div>
    </div>
    <div
      class="totop"
      v-if="navBarFixed"
      @click="gettop()"
    >
      <img src="../assets/img/hj.png" />
    </div>
  </div>
</template>

<script>
import { getNavChannel, getAdvert } from "@/api/common";
export default {
  name: "",
  data() {
    return {
      activeNav: 0,
      navBarFixed: false,
      isClose: true,
      navSubList: [],
      containerStyle: {},
      viewImgTop: true,
      content: "",
      viewSearch: false,
      searchValue: "",
      logo: require("@/assets/img/logogl.png"),
      close: require("@/assets/img/close.png"),
      tooterlimg: require("@/assets/img/tooterl.png"),
      tooterrimg: require("@/assets/img/tooterr.png"),
      // logo2: require("@/assets/img/logo2.png"),
      active: 0,
      navList: [],
      navDown: 0,
      // NEW
      value: "—友情链接—",
      value2: "—行业链接—",
      fakenav: [
        {
          channelId: 3730,
          parentUuid: "0",
          name: "公司概况",
          catalog: 2,
          entTChannelUuid: "0230",
          url: null,
          fileName: "http://img.gsjtzn.cnnull",
          isList: null,
          child: [
            {
              channelId: 3740,
              parentUuid: "0230",
              name: "企业简介",
              catalog: 1,
              entTChannelUuid: "02300001",
              url: null,
              fileName: "http://img.gsjtzn.cn",
              isList: null,
              child: [],
            },
            {
              channelId: 3750,
              parentUuid: "0230",
              name: "组织架构",
              catalog: 1,
              entTChannelUuid: "02300002",
              url: null,
              fileName: "http://img.gsjtzn.cn",
              isList: null,
              child: [],
            },
            {
              channelId: 3760,
              parentUuid: "0230",
              name: "企业资质",
              catalog: 1,
              entTChannelUuid: "02300003",
              url: null,
              fileName: "http://img.gsjtzn.cn",
              isList: null,
              child: [],
            },
            {
              channelId: 4190,
              parentUuid: "0230",
              name: "公司领导",
              catalog: 1,
              entTChannelUuid: "02300004",
              url: null,
              fileName: "http://img.gsjtzn.cn",
              isList: null,
              child: [],
            },
          ],
        },
        {
          channelId: 3770,
          parentUuid: "0",
          name: "新闻中心",
          catalog: 2,
          entTChannelUuid: "0231",
          url: null,
          fileName: "http://img.gsjtzn.cn",
          isList: null,
          child: [
            {
              channelId: 3870,
              parentUuid: "0231",
              name: "安装要闻",
              catalog: 2,
              entTChannelUuid: "02310001",
              url: null,
              fileName: "http://img.gsjtzn.cnnull",
              isList: null,
              child: [],
            },
            {
              channelId: 4130,
              parentUuid: "0231",
              name: "基层动态",
              catalog: 2,
              entTChannelUuid: "02310002",
              url: null,
              fileName:
                "http://img.gsjtzn.cn/newimages/Upload/Image/20230808/fb9657b6223e4c179b09d7ce45242403.jpg",
              isList: null,
              child: [],
            },
            {
              channelId: 3850,
              parentUuid: "0231",
              name: "党的建设",
              catalog: 2,
              entTChannelUuid: "02310003",
              url: null,
              fileName: "http://img.gsjtzn.cnnull",
              isList: null,
              child: [],
            },
            {
              channelId: 3880,
              parentUuid: "0231",
              name: "建投要闻",
              catalog: 2,
              entTChannelUuid: "02310004",
              url: null,
              fileName: "http://img.gsjtzn.cnnull",
              isList: null,
              child: [],
            },
            {
              channelId: 4260,
              parentUuid: "0231",
              name: "媒体聚焦",
              catalog: 2,
              entTChannelUuid: "02310005",
              url: null,
              fileName: "http://img.gsjtzn.cnnull",
              isList: null,
              child: [],
            },
            {
              channelId: 4270,
              parentUuid: "0231",
              name: "甘肃建设报",
              catalog: 2,
              entTChannelUuid: "02310006",
              url: null,
              fileName: "http://img.gsjtzn.cnnull",
              isList: null,
              child: [],
            },
            {
              channelId: 4280,
              parentUuid: "0231",
              name: "电视新闻",
              catalog: 2,
              entTChannelUuid: "02310007",
              url: null,
              fileName: "http://img.gsjtzn.cnnull",
              isList: null,
              child: [],
            },
          ],
        },
        {
          channelId: 4000,
          parentUuid: "0",
          name: "企业文化",
          catalog: 2,
          entTChannelUuid: "0232",
          url: null,
          fileName: "http://img.gsjtzn.cnnull",
          isList: null,
          child: [
            {
              channelId: 4200,
              parentUuid: "0232",
              name: "宣传片",
              catalog: 2,
              entTChannelUuid: "02320001",
              url: null,
              fileName: "http://img.gsjtzn.cnnull",
              isList: null,
              child: [],
            },
            {
              channelId: 4210,
              parentUuid: "0232",
              name: "企业文化",
              catalog: 2,
              entTChannelUuid: "02320002",
              url: null,
              fileName: "http://img.gsjtzn.cnnull",
              isList: null,
              child: [],
            },
            {
              channelId: 4220,
              parentUuid: "0232",
              name: "荣誉奖项",
              catalog: 2,
              entTChannelUuid: "02320003",
              url: null,
              fileName: "http://img.gsjtzn.cnnull",
              isList: null,
              child: [],
            },
            {
              channelId: 4230,
              parentUuid: "0232",
              name: "职工风采",
              catalog: 2,
              entTChannelUuid: "02320004",
              url: null,
              fileName: "http://img.gsjtzn.cnnull",
              isList: null,
              child: [],
            },
            {
              channelId: 4240,
              parentUuid: "0232",
              name: "大事记",
              catalog: 2,
              entTChannelUuid: "02320005",
              url: null,
              fileName: "http://img.gsjtzn.cnnull",
              isList: null,
              child: [
                {
                  channelId: 4300,
                  parentUuid: "02320005",
                  name: "1958",
                  catalog: 2,
                  entTChannelUuid: "023200050001",
                  url: null,
                  fileName: "http://img.gsjtzn.cnnull",
                  isList: null,
                  child: [],
                },
                {
                  channelId: 4310,
                  parentUuid: "02320005",
                  name: "1973",
                  catalog: 2,
                  entTChannelUuid: "023200050002",
                  url: null,
                  fileName: "http://img.gsjtzn.cnnull",
                  isList: null,
                  child: [],
                },
                {
                  channelId: 4320,
                  parentUuid: "02320005",
                  name: "1978",
                  catalog: 2,
                  entTChannelUuid: "023200050003",
                  url: null,
                  fileName: "http://img.gsjtzn.cnnull",
                  isList: null,
                  child: [],
                },
                {
                  channelId: 4330,
                  parentUuid: "02320005",
                  name: "1983",
                  catalog: 2,
                  entTChannelUuid: "023200050004",
                  url: null,
                  fileName: "http://img.gsjtzn.cnnull",
                  isList: null,
                  child: [],
                },
                {
                  channelId: 4340,
                  parentUuid: "02320005",
                  name: "2015",
                  catalog: 2,
                  entTChannelUuid: "023200050005",
                  url: null,
                  fileName: "http://img.gsjtzn.cnnull",
                  isList: null,
                  child: [],
                },
                {
                  channelId: 4350,
                  parentUuid: "02320005",
                  name: "2020",
                  catalog: 2,
                  entTChannelUuid: "023200050006",
                  url: null,
                  fileName: "http://img.gsjtzn.cnnull",
                  isList: null,
                  child: [],
                },
              ],
            },
            {
              channelId: 4030,
              parentUuid: "0232",
              name: "员工文苑",
              catalog: 2,
              entTChannelUuid: "02320006",
              url: null,
              fileName: "http://img.gsjtzn.cnnull",
              isList: null,
              child: [],
            },
            {
              channelId: 4290,
              parentUuid: "0232",
              name: "精品工程",
              catalog: 2,
              entTChannelUuid: "0232007",
              url: null,
              fileName: "http://img.gsjtzn.cnnull",
              isList: null,
              child: [],
            },
          ],
        },
        {
          channelId: 3730,
          parentUuid: "0",
          name: "公司概况",
          catalog: 2,
          entTChannelUuid: "0230",
          url: null,
          fileName: "http://img.gsjtzn.cnnull",
          isList: null,
          child: [
            {
              channelId: 3740,
              parentUuid: "0230",
              name: "企业简介",
              catalog: 1,
              entTChannelUuid: "02300001",
              url: null,
              fileName: "http://img.gsjtzn.cn",
              isList: null,
              child: [],
            },
            {
              channelId: 3750,
              parentUuid: "0230",
              name: "组织架构",
              catalog: 1,
              entTChannelUuid: "02300002",
              url: null,
              fileName: "http://img.gsjtzn.cn",
              isList: null,
              child: [],
            },
            {
              channelId: 3760,
              parentUuid: "0230",
              name: "企业资质",
              catalog: 1,
              entTChannelUuid: "02300003",
              url: null,
              fileName: "http://img.gsjtzn.cn",
              isList: null,
              child: [],
            },
            {
              channelId: 4190,
              parentUuid: "0230",
              name: "公司领导",
              catalog: 1,
              entTChannelUuid: "02300004",
              url: null,
              fileName: "http://img.gsjtzn.cn",
              isList: null,
              child: [],
            },
          ],
        },
      ],
    };
  },
  mounted() {
    this.getPath();
    this.getNavChannel();
    this.active = this.$route.params.id;
    let url = this.$route.name;
    if (url == "home") {
      this.srollimg();
    }
    this.srollChannelTop();
    // 事件监听滚动条
    window.addEventListener("scroll", this.watchScroll);
  },
  created() {},
  watch: {
    $route: "getPath",
  },
  methods: {
    // 吸顶
    watchScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      //  当滚动超过 500 时显示图标
      if (scrollTop > 500) {
        this.navBarFixed = true;
      } else {
        this.navBarFixed = false;
      }
    },
    gettop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    closenav() {
      this.isClose = true;
    },
    shownonenav() {
      this.isClose = false;
    },
    searchSubmit() {
      var _this = this;
      if (!_this.searchValue || _this.searchValue == "") {
        this.$message({
          message: "请输入关键词进行搜索！",
          type: "warning",
          offset: 200,
        });
      } else {
        window.location.href = `/search/${_this.searchValue}`;
        // window.open(`/search/${_this.searchValue}`)
      }
    },
    gosearchpage() {
      window.location.href = `/search`;
    },
    srollimg() {
      var _this = this;
      let data = {
        applicationUuid: _this.webId,
        advertType: 4,
      };
      getAdvert(data).then((res) => {
        const { code, data } = res;
        if (code === 1 && data) {
          data.length && (_this.content = data[0]);
          this.$nextTick(() => {
            // this.srollTop()
          });
        }
      });
    },

    srollChannelTop() {
      var _this = this;
      let url = this.$route.name;
      if (url == "home") {
        setTimeout(() => {
          _this.activeNav = 1;
        }, 4000);
      } else {
        _this.activeNav = 1;
      }
    },
    searchBtn(val) {
      var _this = this;
      _this.viewSearch = val;
    },
    // 获取导航
    getNavChannel() {
      var _this = this;
      let data = {
        applicationUuid: _this.webId,
        // applicationUuid: _this.webIdGroup
      };
      getNavChannel(data).then((res) => {
        const { code, data } = res;
        if (code === 1 && data) {
          _this.navList = data.slice(0, 8);
          // console.log(123456nav,_this.navList)
        }
      });
    },
    // 二级导航展开
    navShow(d) {
      let _this = this;
      // _this[d] = true
      _this.navDown = d;
    },
    // 二级导航收起
    navClose() {
      let _this = this;
      // _this[d] = false
      _this.navDown = 0;
    },
    haddleNav(index, params) {
      var _this = this;

      _this.active = index;
      _this.$router.push(params.url);
    },
    getPath() {
      var _this = this;
      _this.active = _this.$route.meta.index;
    },
    // 友情链接
    selectChange(value) {
      console.log(value), window.open(this.value);
    },
    selectChange2(value2) {
      console.log(value2), window.open(this.value2);
    },
  },
};
</script>
<style>
#topPart,
.top {
  /* display: none; */
  /* width: 100%; */
  height: 90px;
  background-color: #fff;
}
.topLogoMain {
  width: 270px;
  height: 100%;
  float: left;
  overflow: hidden;
  margin: 0 auto;
}
.topLogoMainLeft {
  width: 100%;
  height: 100%;
  text-align: center;
  padding-right: 130px;
  float: left;
}
.topLogoMainLeft img {
  height: 100%;
}
.topLogoMainRight {
  width: 50%;
  height: 100px;
  float: right;
}
.header_search {
  width: 80%;
  float: right;
  margin-top: 30px;
}
.header_search div {
  height: 40px;
  font-size: 14px;
}
.header_search input {
  overflow: hidden;
  line-height: 40px;
  color: #585858;
  border-radius: 0px;
  border: solid 1px #0d65af;
}
.header_search button {
  height: 40px;
  line-height: 40px;
  padding: 0px 12px;
  color: #fff;
  white-space: nowrap;
  text-align: center;
  border: none;
  cursor: pointer;
  /* vertical-align: top; */
  width: 52px;
  background-color: #0d65af;
  border-radius: 0px;
}
.header_search .el-button:hover {
  color: black;
  background-color: rgb(13, 101, 175);
}
.header_search .el-button:focus {
  color: rgb(255, 255, 255);
  border-color: #c6e2ff;
  background-color: rgb(54, 154, 236);
}
/* 导航菜单 */
.topMenu {
  width: calc(100% - 380px);
  height: 90px;
  float: right;
  overflow: hidden;
  border-bottom: 1px #ffffff solid;
}
.nav_box {
  margin: 0 auto;
  height: 100%;
  white-space: nowrap;
}
.nav_box_list {
  width: calc(100% - 50px);
  height: 100%;
  float: left;
  /* margin: 0 auto; */
  white-space: nowrap;
  overflow-x: scroll;
}

.nav_box_list::-webkit-scrollbar {
  display: none;
}
.nav_box_list li {
  /* float: left; */
  display: inline-block;
  height: 90px;
  width: 12.5%;
  line-height: 90px;
  text-align: center;
}

.nav_box_list li h2 a {
  display: block;
  font-size: 18px;
  position: relative;
}
/* .nav_box_list li:hover h2 a {
  color: #fff;
  background-color: rgba(2, 99, 180);
} */
.nav_box_list li .hoverline {
  width: 0;
  height: 2px;
  transition: width 0.5s;
  -webkit-transition: width 0.5s;
}
.nav_box_list li:hover .hoverline {
  width: 100%;
  height: 2px;
  background-color: #0062b1;
  position: relative;
  left: 50%;
  top: -2px;
  transform: translateX(-50%);
}
.searchicon {
  height: 90px;
  width: 50px;
  float: right;
  text-align: right;
}
.searchicon img {
  height: 16px;
  width: 16px;
  margin-top: 36px;
  /* line-height: 90px; */
}
.searchicon:hover {
  cursor: pointer;
}
.nav_down {
  border-top: 1px #d2d2d2 solid;
  position: absolute;
  width: 100%;
  background-color: rgba(255, 255, 255, 1);
  color: #fff;
  left: 0;
  top: 90px;
  text-align: left;
  z-index: 100;
}
.nav_down_wrap {
  height: 58.33px;
  line-height: 58.33px;
}
.nav_down a {
  color: #000;
  font-size: 14px;
  line-height: 58px;
  margin-right: 45px;
}
.nav_down a:hover {
  /* font-weight: bold; */
  color: #0062b1;
}
.nav_down p {
  display: inline-block;
}

.form-control {
  display: block;
  padding: 6px 12px;
}
.containerMain {
  -moz-transition: all 1s ease-in;
  -webkit-transition: all 1s ease-in;
  -o-transition: all 1s ease-in;
  transition: all 1s ease-in;
  z-index: 10;
  background-color: #fff;
}
.el-menu-item {
  width: 148px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  float: left;
  color: #ffffff;
  display: block;
  font-size: 16px;
  font-weight: 600;
}
.el-menu-item2 {
  width: 148px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  float: left;
  color: #ffffff;
  display: block;
  font-size: 16px;
  font-weight: 600;
}
.el-menu-item:hover {
  background-color: rgba(7, 6, 63, 0.425) !important;
}
.el-menu--horizontal > .el-menu-item {
  float: left;
  height: 60px;
  line-height: 52px;
  margin: 0;
  border-bottom: 2px solid transparent;
}
.el-menu .span1 {
  width: 2px;
  height: 50px;
  background: url(../assets/image/menu_line.jpg) center center no-repeat;
  display: inline-block;
}
.el-menu .span2 {
  width: 2px;
  height: 50px;
  display: inline-block;
}
.footerBox {
  background: #323232;
  color: rgba(255, 255, 255, 0.2);
  /* padding: 60px 0 40px;
  background-color: #0062b1;
  color: #fff;
  font-size: 16px; */
}
.footerall {
  padding: 60px 15px 30px 15px;
}
.footertop {
  width: 100%;
}
.footertopL {
  width: 25%;
  line-height: 28px;
}
.footertopL p:nth-child(2) {
  margin-top: 20px;
}
.footertopM {
  width: 50%;
  margin-left: 15%;
}
.footnav {
  width: 100%;
}
.footnav li {
  margin-right: 60px;
  width: calc(25% - 60px);
}
.footnav li a {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.5);
  font-family: "微软雅黑";
}
.footnav li ul {
  padding-top: 10px;
}
.footnav li ul li {
  width: 100%;
}
.footnav li ul li a {
  color: rgba(255, 255, 255, 0.2);
  line-height: 28px;
  font-family: "微软雅黑";
  font-size: 14px;
}
.footertopR {
  width: 8.33333%;
}
.footerbot {
  border-top: 1px solid #474747;
  text-align: center;
  padding-top: 30px;
  margin-top: 40px;
  font-size: 14px;
  font-family: "微软雅黑";
  color: #ffffff33;
}
.footerbot a {
  font-size: 14px;
  font-family: "微软雅黑";
  color: #ffffff33;
}
.footerbot span,
.footerbot a {
  margin: 0 2px;
}
.totop {
  position: fixed;
  right: 0;
  bottom: 20px;
  cursor: pointer;
  width: 42px;
  height: 42px;
  z-index: 999;
}
.totop img {
  width: 100%;
  height: 100%;
}
.navnone {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  overflow-y: auto;
  z-index: 999999;
  background: rgba(0, 0, 0, 0.9);
}
.navnone .close {
  width: 24px;
  position: absolute;
  right: 20px;
  top: 24px;
}
.navnone a {
  display: block;
  font-size: 20px;
  color: #fff;
  transition: all 0.3s;
  -webkit-transition: all 0.3s;
}
.navnone a img {
  width: 100%;
}
.navnone ul {
  margin: 99px 0 65px;
}
.navnone ul li {
  margin-bottom: 19px;
  text-align: center;
}
.navnone ul .innerul {
  margin: 30px 0;
}
.navnone ul .innerul li a {
  padding-bottom: 10px;
  display: inline-block;
  color: #fff;
  font-size: 14px;
}
.shownavnone {
  display: none;
  margin: 20px;
  width: 20px;
  float: right;
}
.shownavnone a {
  width: 20px;
  height: 17px;
  display: block;
  position: relative;
}
.shownavnone a span:nth-child(1) {
  width: 20px;
  height: 2px;
  position: absolute;
  left: 0;
  top: 0;
  background: #0062b3;
  transition: all 0.3s;
  -webkit-transition: all 0.3s;
}
.shownavnone a span:nth-child(2) {
  width: 20px;
  height: 2px;
  position: absolute;
  left: 0;
  top: 7px;
  background: #0062b3;
  transition: all 0.3s;
  -webkit-transition: all 0.3s;
}
.shownavnone a span:nth-child(3) {
  width: 10px;
  top: 15px;
  height: 2px;
  display: block;
  position: absolute;
  left: 0;
  background: #0062b3;
  transition: all 0.3s;
  -webkit-transition: all 0.3s;
}
.shownavnone a:hover span:nth-child(1) {
  width: 7px;
}
.shownavnone a:hover span:nth-child(2) {
  width: 14px;
}
.shownavnone a:hover span:nth-child(3) {
  width: 20px;
}
@media (max-width: 1366px) {
  .header_search .el-input {
    width: 80% !important;
  }
  .header_search {
    margin-top: 35px;
  }
  .nav_box_list {
    width: 90%;
  }
}
@media (max-width: 1200px) {
  .topMenu {
    width: calc(100% - 270px);
  }
  .footertopM {
    margin-left: 0;
    width: 65%;
  }
  .footnav li {
    margin-right: 0px;
    width: 25%;
  }
}
@media (max-width: 992px) {
  .shownavnone {
    display: block;
  }
  #topPart,
  .top,
  .topLogoMain {
    height: 60px;
  }
  .topMenu {
    display: none;
  }
  .footerall {
    padding: 30px 15px 30px 15px;
  }
  .footertopL,
  .footertopM,
  .footertopR {
    width: 100%;
  }
  .topLogoMainLeft,
  .topLogoMainRight {
    width: 100%;
    height: auto;
    float: none;
  }
  .topLogoMainLeft {
    height: 60px;
  }
  .topLogoMainLeft img {
    height: 100%;
  }
  .header_search {
    width: 80%;
    margin-top: 0px;
  }
  .header_search .el-input {
    width: 60% !important;
  }
}
@media (max-width: 768px) {
  .footertopL p:nth-child(1),
  .footertopM,
  .footertopR {
    display: none;
  }
  .nav_box {
    width: 100%;
  }
  .nav_box_list li {
    width: 80px;
  }
}
</style>
